import './style.css';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Form,
  Radio,
  Slider,
  TimePicker,
  Button,
  InputNumber,
  message
} from 'antd';
import { API_DASHBOARD } from '../../../../commons/api';
import localStorage from '../../../../utils/localStorage';

const SmartLightControl = () => {
  const [HighMast3, setHighMast3] = useState({
    activateLights: moment().format('HH:mm'),
    deActivateLights: moment().format('HH:mm')
  });
  const [HighMast4, setHighMast4] = useState({
    activateLights: moment().format('HH:mm'),
    deActivateLights: moment().format('HH:mm')
  });
  const [mode, setMode] = useState('Mode 1');
  const [HighMast3IluminationSetPoint, setHighMast3IluminationSetPoint] = useState(0);
  const [HighMast4IluminationSetPoint, setHighMast4IluminationSetPoint] = useState(0);

  useEffect(() => {
    document.title = 'Rubus-Smart Control Form';
    getFormData();
  }, []);

  const getFormData = () => {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    axios({
      method: 'GET',
      url: `${API_DASHBOARD.GetSmartFormData}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((res) => {
        const formData = res.data;
        let HighMast3 = {};
        let HighMast4 = {};
        let HighMast3IluminationSetPoint = '';
        let HighMast4IluminationSetPoint = '';

        formData.forEach((data) => {
          if (data.AssetName === 'HighMast-3') {
            HighMast3IluminationSetPoint = data.Ilumination_Set_Point;
            HighMast3 = {
              activateLights: data.Activate_Lights,
              deActivateLights: data.Deactivate_Lights
            };
          } else if (data.AssetName === 'HighMast-4') {
            HighMast4IluminationSetPoint = data.Ilumination_Set_Point;
            HighMast4 = {
              activateLights: data.Activate_Lights,
              deActivateLights: data.Deactivate_Lights
            };
          }
        });

        setHighMast3(HighMast3);
        setHighMast4(HighMast4);
        setHighMast3IluminationSetPoint(HighMast3IluminationSetPoint);
        setHighMast4IluminationSetPoint(HighMast4IluminationSetPoint);
      })
      .catch(() => { });
  };

  const handleSubmit = () => {
    let payload = [];

    if (mode === 'Mode 1') {
      if (!HighMast3IluminationSetPoint || !HighMast4IluminationSetPoint) {
        message.error('Please Provide SetPoints');
        return;
      }

      payload = [
        {
          modeType: mode,
          deviceId: 'HighMast-3',
          iluminationSetPoint: HighMast3IluminationSetPoint
        },
        {
          modeType: mode,
          deviceId: 'HighMast-4',
          iluminationSetPoint: HighMast4IluminationSetPoint
        }
      ];
    }

    if (mode === 'Mode 2') {
      if (
        !HighMast3.activateLights ||
        !HighMast3.deActivateLights ||
        !HighMast4.activateLights ||
        !HighMast4.deActivateLights
      ) {
        message.error('Please Provide TimeStamp');
        return;
      }

      payload = [
        {
          modeType: mode,
          deviceId: 'HighMast-3',
          activateLights: HighMast3.activateLights,
          deActivateLights: HighMast3.deActivateLights
        },
        {
          modeType: mode,
          deviceId: 'HighMast-4',
          activateLights: HighMast4.activateLights,
          deActivateLights: HighMast4.deActivateLights
        }
      ];
    }

    formSubmittion(payload);
  };

  const formSubmittion = (payload) => {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');

    axios({
      method: 'POST',
      url: `${API_DASHBOARD.SmartControlForm}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
      .then(() => {
        message.success('Submitted Successfully');
      })
      .catch((err) => {
        console.log(err);
        message.error('Submission Failed');
      });
  };

  const getDisabledHours = (status) => {
    if (status === 'activate') {
      return Array.from({ length: 12 }, (_, i) => i);
    } else if (status === 'deActivate') {
      return [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
    }
    return [];
  };

  const format = 'HH:mm';

  return (
    <div style={{ padding: '20px' }}>
      <Form layout="vertical">
        <Row justify="center">
          <Col xs={24} sm={16} md={12}>
            <Form.Item label="Auto Control Mode">
              <Radio.Group onChange={(e) => setMode(e.target.value)} value={mode}>
                <Radio value="Mode 1">Mode 1</Radio>
                <Radio value="Mode 2">Mode 2</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        {mode === 'Mode 1' && (
          <>
            {[{
              label: 'HighMast-3',
              value: HighMast3IluminationSetPoint,
              setter: setHighMast3IluminationSetPoint
            }, {
              label: 'HighMast-4',
              value: HighMast4IluminationSetPoint,
              setter: setHighMast4IluminationSetPoint
            }].map((item, idx) => (
              <Row gutter={[16, 16]} align="middle" justify="center" key={idx}>
                <Col xs={24} sm={8} style={{ textAlign: 'center' }}>
                  <h4 style={{ fontWeight: 'bold' }}>
                    {item.label} Ilumination Set Point (3 to 70,000):
                  </h4>
                </Col>
                <Col xs={16} sm={8}>
                  <Slider
                    min={3}
                    max={70000}
                    onChange={item.setter}
                    value={item.value}
                    tooltip={{ formatter: (val) => `${val}` }}
                  />
                </Col>
                <Col xs={8} sm={4}>
                  <InputNumber
                    min={3}
                    max={70000}
                    value={item.value}
                    onChange={item.setter}
                    style={{ width: '100%' }}
                  />
                </Col>
              </Row>
            ))}
          </>
        )}

        {mode === 'Mode 2' && (
          <Row gutter={[24, 24]} justify="center">
            {[{
              label: 'HighMast-3',
              data: HighMast3,
              setData: setHighMast3
            }, {
              label: 'HighMast-4',
              data: HighMast4,
              setData: setHighMast4
            }].map((mast, idx) => (
              <Col xs={24} sm={12} key={idx}>
                <h4 style={{ textAlign: 'center', fontWeight: 'bold' }}>{mast.label}</h4>
                <Form.Item label="Activate Lights:">
                  <TimePicker
                    style={{ width: '100%' }}
                    disabledHours={() => getDisabledHours('activate')}
                    defaultValue={
                      mast.data?.activateLights
                        ? moment(mast.data.activateLights, format)
                        : null
                    }
                    format={format}
                    onChange={(time, timeString) => {
                      mast.setData({
                        ...mast.data,
                        activateLights: timeString
                      });
                    }}
                  />
                </Form.Item>
                <Form.Item label="Deactivate Lights:">
                  <TimePicker
                    style={{ width: '100%' }}
                    disabledHours={() => getDisabledHours('deActivate')}
                    defaultValue={
                      mast.data?.deActivateLights
                        ? moment(mast.data.deActivateLights, format)
                        : null
                    }
                    format={format}
                    onChange={(time, timeString) => {
                      mast.setData({
                        ...mast.data,
                        deActivateLights: timeString
                      });
                    }}
                  />
                </Form.Item>
              </Col>
            ))}
          </Row>
        )}

        <Row justify="center">
          <Col xs={24} sm={12} style={{ textAlign: 'center' }}>
            <Button
              type="primary"
              shape="round"
              size="large"
              onClick={handleSubmit}
              style={{ marginTop: '40px' }}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SmartLightControl;

